import { ReactNode } from 'react';

import { isWebBuild } from '../functions';

interface Props {
  children?: ReactNode;
}

export const WebOnly = ({ children }: Props) =>
  isWebBuild() ? <>{children}</> : null;
